<template>
  <div class="mb-5">
    <div class="pdf-icon">
      <a @click="createPdf">
        <img src="@/assets/images/pdf.png" alt="PDF" height="32" />
      </a>
    </div>
    <div id="alcohol-report" className="xz-report">
      <AlcoholReportHeader :location="location" :fromDate="fromDate" :toDate="toDate" />
      <AlcoholReportTotalSales :zReports="zReports" :vat="vat" />
      <AlcoholReportCategories :zReports="zReports" :vat="vat" />
      <!-- AlcoholReportProducts :zReports="zReports" :vat="vat" /-->
    </div>
  </div>
</template>

<script>
import AlcoholReportHeader from "@/components/report/alcohol/AlcoholReportHeader.vue";
import AlcoholReportTotalSales from "@/components/report/alcohol/AlcoholReportTotalSales";
import AlcoholReportCategories from "@/components/report/alcohol/AlcoholReportCategories";

import ReportPdfBuilder from "@/util/ReportPdfBuilder";

export default {
  components: {AlcoholReportHeader, AlcoholReportTotalSales, AlcoholReportCategories},
  props: {
    zReports: Array,
    vat: Object,
    company: Object,
    location: Object,
    fromDate: String,
    toDate: String
  },
  methods: {
    createPdf() {
      ReportPdfBuilder.buildAlcoholReportPdf(this.zReports, this.location, this.vat, this.fromDate, this.toDate);
    }
  }
}
</script>